import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function HeroSection() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = () => {
    if (searchQuery.trim() !== '') {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    } else {
      navigate('/search');
    }
  };

  return (
    <section className="bg-gradient-to-br from-red-900 to-red-700 text-white py-20 px-4 text-center relative overflow-hidden">
      <div className="max-w-2xl mx-auto z-10 relative">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-4 drop-shadow-lg">Compare Prices Instantly</h1>
        <p className="text-lg md:text-xl mb-2 font-light drop-shadow">Real prices. Real receipts. Real savings.</p>
        <p className="text-sm md:text-base mb-8 opacity-90 max-w-lg mx-auto">Every price you see was verified by a real receipt from a real shopper near you &mdash; not scraped listings or advertised deals.</p>
        <div className="flex flex-col md:flex-row gap-2 justify-center items-center mb-6">
          <input
            type="text"
            placeholder="Search for products, brands, or stores..."
            className="w-full md:w-96 px-4 py-3 rounded shadow text-gray-800 focus:outline-none focus:ring-2 focus:ring-amber-400"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
          />
          <button
            className="bg-amber-500 hover:bg-amber-600 text-white font-semibold px-6 py-3 rounded shadow mt-2 md:mt-0 md:ml-2 transition"
            onClick={handleSearch}
          >
            Compare Now
          </button>
        </div>
        <div className="text-sm opacity-80">
          {isAuthenticated ? (
            <span>Or <span className="underline cursor-pointer" onClick={() => navigate('/upload')}>upload a receipt</span> to earn more searches</span>
          ) : (
            <span><span className="underline cursor-pointer font-semibold" onClick={() => navigate('/register')}>Sign up free</span> &mdash; start comparing prices</span>
          )}
        </div>
      </div>
      <div className="absolute -top-16 -left-16 w-64 h-64 bg-white bg-opacity-10 rounded-full blur-2xl z-0" />
      <div className="absolute -bottom-16 -right-16 w-64 h-64 bg-white bg-opacity-10 rounded-full blur-2xl z-0" />
    </section>
  );
}
